// Deterministic initials-avatar styling — one shared palette/hash so the
// same person reads with the same color everywhere a colored initials
// circle is used (candidate rows, interviewer pickers, ...), rather than
// each call site inventing its own. Same algorithm CandidateCell.jsx
// originated; extracted here once a second consumer (the interviewer
// multi-select) needed the identical treatment.
const AVATAR_PALETTE = [
  { bg: 'bg-blue-100', text: 'text-blue-700' },
  { bg: 'bg-purple-100', text: 'text-purple-700' },
  { bg: 'bg-amber-100', text: 'text-amber-700' },
  { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  { bg: 'bg-rose-100', text: 'text-rose-700' },
];

export const getInitials = (name) => {
  const parts = (name || '').split(' ').filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Picks a palette entry off a stable seed (name, id, ...) so the same
// seed always lands on the same color across re-renders/pages/components.
export const paletteForSeed = (seed) => {
  const str = seed || '';
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) % AVATAR_PALETTE.length;
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};
